import * as React from 'react';
import { cn } from '@/lib/utils';

interface ListPageProps {
  children: React.ReactNode;
  className?: string;
}

interface ListPageHeaderProps {
  children: React.ReactNode;
  className?: string;
}

interface ListPageTitleProps {
  children: React.ReactNode;
  subtitle?: string;
  className?: string;
}

interface ListPageActionsProps {
  children: React.ReactNode;
  className?: string;
}

interface ListPageCardProps {
  children: React.ReactNode;
  className?: string;
}

interface ListPageFiltersProps {
  children: React.ReactNode;
  className?: string;
}

interface ListPageStatsProps {
  children: React.ReactNode;
  className?: string;
}

interface ListPageContentProps {
  children: React.ReactNode;
  className?: string;
}

function ListPage({ children, className }: ListPageProps) {
  return (
    <div className={cn('pb-6', className)}>
      {children}
    </div>
  );
}

function ListPageHeader({ children, className }: ListPageHeaderProps) {
  return (
    <div className={cn('px-6 pt-6 pb-4', className)}>
      <div className="flex items-center justify-between">
        {children}
      </div>
    </div>
  );
}

function ListPageTitle({ children, subtitle, className }: ListPageTitleProps) {
  return (
    <div className={cn('', className)}>
      <h1 className="text-2xl font-bold">
        {children}
      </h1>
      {subtitle && (
        <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
      )}
    </div>
  );
}

function ListPageActions({ children, className }: ListPageActionsProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      {children}
    </div>
  );
}

function ListPageCard({ children, className }: ListPageCardProps) {
  return (
    <div className={cn('mx-6 bg-card rounded-xl border shadow-sm overflow-hidden', className)}>
      {children}
    </div>
  );
}

function ListPageFilters({ children, className }: ListPageFiltersProps) {
  return (
    <div className={cn('px-6 py-4 border-b flex flex-wrap items-center gap-4', className)}>
      {children}
    </div>
  );
}

function ListPageStats({ children, className }: ListPageStatsProps) {
  return (
    <div className={cn('px-6 py-4 border-b flex gap-12', className)}>
      {children}
    </div>
  );
}

function ListPageContent({ children, className }: ListPageContentProps) {
  return (
    <div className={cn('', className)}>
      {children}
    </div>
  );
}

export {
  ListPage,
  ListPageHeader,
  ListPageTitle,
  ListPageActions,
  ListPageCard,
  ListPageFilters,
  ListPageStats,
  ListPageContent,
};
